import React, { ReactNode } from "react";
import { Container } from "rsuite";
import SvgLoader from "@client/components/SvgLoader";

export enum EnumLoadingType {
  Default,
  Spinner
}
export enum EnumLoadingMode {
  FullSize,
  Inline
}

type LoadingProps = {
  type?: EnumLoadingType,
  overlay?: boolean,
  mode?: EnumLoadingMode,
  children?: ReactNode
}

const overlayStyle = {
  animation: 'fade_content 1s linear',
  background: 'hsl(0deg 0% 0% / 70%)',
  color: '#fff',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  'zIndex': 100,
} as React.CSSProperties
const loadingContentStyle = {
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'center',
  width: '100%',
  zIndex: 10,
} as React.CSSProperties

export default function Loading({ type = EnumLoadingType.Default, overlay = true, mode = EnumLoadingMode.FullSize, children }: LoadingProps) {
  let containerStyle = {} // default: no special styling, just a wrapper
  if (overlay) containerStyle = overlayStyle // full screen overlay

  if (mode === EnumLoadingMode.Inline) {
    let inlineStyle = {
      position: 'absolute',
      background: 'hsl(0deg 0% 0% / 30%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    } as React.CSSProperties
    containerStyle = { ...containerStyle, ...inlineStyle }
  }

  return (
    <Container style={containerStyle}>
      {type == EnumLoadingType.Default &&
        <div id="global-loader" >
          <div />
          <div />
          <div />
          <div />
        </div>
      }
      {type == EnumLoadingType.Spinner &&
        <div id="global-loader-spinner">
          <SvgLoader file="/images/spinner-loader.svg" />
        </div>
      }
      <div style={loadingContentStyle}>
        {children}
      </div>
    </Container>
  )
}